
import React from 'react';
import Button from '../../Button';
import FontAwesomeIcon from '../../Icon';
import { SortIcon } from './SortIcon';

export const AddFaqComponent = ({ faqs, data, onAddFaq, onSetFaq, onSetEditFaq, handleFaqDelete, onSortingFAQ, orderId, onClearFormData }) => {
   let validation = data.faqTitle && data.faqTitle.trim() && data.faqDescription && data.faqDescription.trim();
   let isIdsAvailable = faqs && faqs.length > 0 ? faqs.filter(faq => faq.id) : []
    return (
        <div class="input_box">
            {faqs && faqs.length > 0 ?
                faqs.filter(q => !q.isdeleted).
                    map((faq, index) => {
                        return (
                            <>
                                <div className='homeOwnercard mt-15 mb-15'
                                   draggable={isIdsAvailable && isIdsAvailable.length === 0 || faq.id ? true : false}
                                   onDragStart={() => onSortingFAQ(faq, index, 'start')}
                                   onDrop={() => onSortingFAQ(faq, index, 'drop')}
                                   onDragOver={ (e) => { e.stopPropagation(); e.preventDefault();
                                   }}
                                >
                                    {isIdsAvailable && isIdsAvailable.length === 0 || faq.id ? <SortIcon /> : null}
                                    <div className='deleteIcon' style={{ textAlign: 'right', cursor: 'pointer', float: 'right' }}
                                      onClick={() => window.confirm(`Are you sure you want to delete FAQ?`) && handleFaqDelete(faq)}
                                    >
                                        <FontAwesomeIcon
                                            glyph="trash"
                                            weight="light"
                                            size="small"
                                        />
                                        Delete FAQ
                                    </div>
                                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                                        <div class='mt-10 tabsInputLable'>Question:<span className='input__required'/> </div>
                                        <div class='tabsInputForm'>
                                            <input class="form-control" type="text" placeholder="Question" aria-label="default input example"
                                                value={faq.name}
                                                onChange={e => onSetEditFaq(e.target.value, 'name', index)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                                        <div class='mt-10 tabsInputLable pr-10'>Answer:<span className='input__required'/> </div>
                                        <div class='tabsInputForm'>
                                            <textarea class="form-control" placeholder="Answer" id="floatingTextarea2"
                                                style={{ height: '100px', resize:'none' }}
                                                onChange={e => onSetEditFaq(e.target.value, 'description', index)}
                                                value={faq.description}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                </div>
                            </>
                        )
                    }) : null}
            <>
                <div className='homeOwnercard mt-15 mb-15'>
                {data.faqTitle || data.faqDescription ?
                    <a onClick={() => onClearFormData('faq')} className='clearLink deleteIcon' style={{ textAlign: 'right', cursor: 'pointer', float: 'right' }}> Clear </a> : null}
                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                        <div class='mt-10 tabsInputLable'>Question:<span className='input__required'/> </div>
                        <div class='tabsInputForm'>
                            <input class="form-control" type="text" placeholder="Question" aria-label="default input example"
                                value={data.faqTitle}
                                onChange={e => onSetFaq(e.target.value, 'faqTitle')}
                                required
                            />
                        </div>
                    </div>
                    <div className="input__errors">
                        {data.faqValidation && <div className="input__error">{data.faqValidation}</div>}
                    </div>  
                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                        <div class='mt-10 tabsInputLable pr-10'>Answer:<span className='input__required'/> </div>
                        <div class='tabsInputForm'>
                            <textarea class="form-control" placeholder="Answer" id="floatingTextarea2"
                                style={{ height: '100px', resize:'none' }}
                                onChange={e => onSetFaq(e.target.value, 'faqDescription')}
                                value={data.faqDescription}
                            ></textarea>
                        </div>
                    </div>
                </div>
            </>
            <Button
                color="teal"
                size="small"
                label="+ Add New FAQ"
                disabled={!validation}
                onClick={onAddFaq}
            />
        </div>
    )
}